import { render, staticRenderFns } from "./user-level-column.vue?vue&type=template&id=c15c04f0"
import script from "./user-level-column.vue?vue&type=script&lang=js"
export * from "./user-level-column.vue?vue&type=script&lang=js"
import style0 from "./user-level-column.vue?vue&type=style&index=0&id=c15c04f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports